<template>
  <v-container class="px-7" fluid>
    <v-row no-gutters align="center" justify="space-between" class="mt-2">
      <v-col cols="12" sm="6">
        <h1 class="fs-20 font-weight-bold bluedarken--text">
          Dashboard {{ item.name }}
        </h1>
      </v-col>
      <v-col cols="12" sm="auto">
        <v-btn color="primary" icon large>
          <v-icon
            class="icon-large icon-bold"
            color="bluedarken"
            @click="refresh"
          >
            mdi-refresh
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row no-gutters align="center" justify="space-between" class="px-1 mb-3">
      <v-expansion-panels flat class="filterby-info" v-model="panelFilter">
        <v-expansion-panel>
          <v-expansion-panel-header
            class="primary--text fs-13 px-0 pt-0 pb-1 secondary"
            height="100px"
          >
            Filter By Information
          </v-expansion-panel-header>
          <v-expansion-panel-content class="grey--text secondary">
            <table width="auto" v-if="filterInfo.length > 0">
              <tr
                v-for="(filter, index) in filterInfo"
                :key="'filter' + index"
                class="text-left mb-0 text-capitalize fs-13"
              >
                <!-- name filter -->
                <td class="font-weight-bold">
                  <span v-if="filter.name === 'type_of_activity'">
                    Activity
                  </span>
                  <span v-if="filter.name !== 'status'">
                    {{ filter.name.split('_').join(' ') }}
                  </span>
                  <span v-else>
                    {{ filter.name }}
                  </span>
                </td>
                <!-- value filter -->
                <td class="pl-3">
                  <span v-if="filter.name === 'status'">
                    {{
                      filter.value
                        .join(', ')
                        .split('_')
                        .join(' ')
                    }}
                  </span>
                  <span v-else-if="filter.name === 'house'">
                    {{ filter.value.name }}
                  </span>
                  <span v-else-if="filter.name === 'start_year'">
                    {{ formatYear(filter.value) }}
                  </span>
                  <span v-else>
                    {{ filter.value }}
                  </span>
                </td>
              </tr>
            </table>

            <span v-else class="fs-13">
              No filter exists.
            </span>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>

    <v-row align="start" justify="space-between">
      <v-col cols="12" sm="12" md="9">
        <v-card :loading="loading" class="elevation-card rounded-10">
          <v-card-title>
            <!--              <v-icon color="primary" class="mr-2">-->
            <!--                mdi-web-->
            <!--              </v-icon>-->
            <div>
              <div class="fs-20 lh-24 font-weight-bold primary--text">
                Request
              </div>
              <div class="fs-12 font-weight-regular grey--text lh-15">
                by {{ item.name }}
              </div>
            </div>
          </v-card-title>

          <dashboard-chart :item="item" />
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="3">
        <v-row>
          <template v-if="loading">
            <v-col
              cols="12"
              sm="4"
              md="12"
              v-for="(stat, index) in stats"
              :key="stat.title + index"
              :class="{ 'pt-0': index === 0 }"
            >
              <v-skeleton-loader height="100" type="image" />
            </v-col>
          </template>

          <v-col
            v-else
            cols="12"
            sm="4"
            md="12"
            v-for="(stat, index) in stats"
            :key="index"
            :class="{ 'pt-0 pb-1': $vuetify.breakpoint.mdAndUp && index === 0 }"
          >
            <v-card
              class="py-3 fill-height px-3 align-center d-flex rounded-10 elevation-card"
            >
              <v-row dense align="center">
                <v-col cols="3">
                  <v-img
                    width="36"
                    height="36"
                    contain
                    :src="require(`@/assets/images/${stat.icon}.png`)"
                    class="mx-auto"
                  ></v-img>
                </v-col>
                <v-col cols="9">
                  <div class="fs-12 menuActive--text font-weight-bold">
                    {{ stat.title }}
                  </div>
                  <div class="primary--text fs-24 font-weight-bold">
                    {{ stat.count }}
                  </div>
                  <div class="fs-12 grey--text font-weight-bold">
                    Total
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-card :loading="loading" class="elevation-card rounded-12 mb-8">
      <v-card-title>
        <div class="mr-2">
          <v-img
            src="@/assets/images/icon-file-text.png"
            width="20"
            height="20"
          />
        </div>
        <span class="fs-14 font-weight-bold bluedarken--text">
          Summary by {{ item.name }}
        </span>
        <v-spacer />
        <select-column-filter v-model="columnActive" :headers="headers" />
        <v-btn
          depressed
          dark
          color="menuActive"
          class="btn-medium"
          @click="download('item')"
          :loading="downloading.item"
        >
          Download
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-simple-table class="nav-table">
          <template v-slot:default>
            <thead>
              <tr>
                <template v-for="(header, index) in headers">
                  <th
                    v-if="isHeaderSelected(header, columnActive)"
                    :key="header.text"
                    class="white--text"
                    :class="{ [`text-${header.align}`]: true }"
                  >
                    <span>{{ header.text }}</span>
                    <filter-column
                      v-if="header.value !== 'action'"
                      :indexItem="index"
                      :field="header.value"
                      :listFilter="getFiltered(header.value, items)"
                      @sortAsc="getNestedSort($event, items)"
                      @searchColumn="searchCln"
                      @filterItem="searchCln"
                    />
                  </th>
                </template>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(val, index) in filteredItems" :key="index">
                <template v-for="header in headers">
                  <td
                    v-if="isColumnSelected(header.value, columnActive)"
                    :key="header.name"
                    :class="{
                      [header.tdClass]: true,
                      [`text-${header.align}`]: true
                    }"
                  >
                    <template v-if="header.value === 'amount_budget'">
                      {{ idr(val.amount_budget) }}
                    </template>
                    <template v-else-if="header.value === 'ctr'">
                      {{ val.ctr.toFixed(2) }}
                    </template>
                    <template v-else-if="header.value === 'average_budget'">
                      {{ idr(val.average_budget) }}
                    </template>
                    <template v-else-if="header.value === 'action'">
                      <v-btn
                        text
                        color="primary"
                        class="text-capitalize font-weight-bold"
                        :to="toDetail(val, item.name)"
                      >
                        <v-img
                          src="@/assets/images/icon-doc.png"
                          width="16"
                          height="16"
                          class="mr-2"
                          v-if="index !== filteredItems.length"
                        />
                        Details
                      </v-btn>
                    </template>
                    <span v-else>
                      {{ header | tableRowValue(val) }}
                    </span>
                  </td>
                </template>
              </tr>
              <tr v-if="filteredItems.length" class="total">
                <td v-if="isHeaderSelectedByValue('name', columnActive)">
                  Total SN ID
                </td>
                <td
                  v-if="
                    isHeaderSelectedByValue('number_of_requests', columnActive)
                  "
                  class="text-right"
                >
                  {{ totalRequest(items) }}
                </td>
                <td
                  v-if="isHeaderSelectedByValue('amount_budget', columnActive)"
                  class="text-right"
                >
                  {{ totalBudget(items) | toCurrencyWithoutSign }}
                </td>
                <td
                  v-if="isHeaderSelectedByValue('ctr', columnActive)"
                  class="text-right"
                >
                  {{ totalCtr(items) }} %
                </td>
                <td
                  v-if="isHeaderSelectedByValue('average_budget', columnActive)"
                ></td>
                <td v-if="isHeaderSelectedByValue('action', columnActive)"></td>
              </tr>
              <tr v-if="!filteredItems.length">
                <td :colspan="headers.length" class="text-center">
                  {{ loading ? 'Loading...' : 'No data available' }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
    <v-row align="start" justify="space-between">
      <!-- pie chart -->
      <v-col cols="12" sm="12" md="4" class="mb-5">
        <v-card :loading="loadingBudget" class="elevation-card rounded-10">
          <v-card-title>
            <!--              <v-icon color="primary" class="mr-2">-->
            <!--                mdi-web-->
            <!--              </v-icon>-->
            <div>
              <div class="fs-20 lh-24 font-weight-bold primary--text">
                Budget
              </div>
            </div>
          </v-card-title>

          <DashboardPieChart :item="item" type="budget" />
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="8" class="mb-3">
        <v-card :loading="loading" class="elevation-card rounded-10">
          <v-row>
            <v-col cols="6" class="py-0">
              <v-card-title>
                <!--              <v-icon color="primary" class="mr-2">-->
                <!--                mdi-web-->
                <!--              </v-icon>-->
                <div>
                  <div class="fs-20 lh-24 font-weight-bold primary--text">
                    Activity
                  </div>
                  <div class="fs-12 font-weight-regular grey--text lh-15">
                    by Amount
                  </div>
                </div>
              </v-card-title>

              <DashboardPieChart :item="item" type="activityAmount" />
            </v-col>
            <v-col cols="6" class="py-0">
              <v-card-title>
                <!--              <v-icon color="primary" class="mr-2">-->
                <!--                mdi-web-->
                <!--              </v-icon>-->
                <div>
                  <div class="fs-20 lh-24 font-weight-bold primary--text">
                    Activity
                  </div>
                  <div class="fs-12 font-weight-regular grey--text lh-15">
                    by Request
                  </div>
                </div>
              </v-card-title>

              <DashboardPieChart :item="item" type="activityRequest" />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-card :loading="loading" class="elevation-card rounded-12 mt-4">
      <v-card-title>
        <div class="mr-2">
          <v-img
            src="@/assets/images/icon-file-text.png"
            width="20"
            height="20"
          />
        </div>
        <span class="fs-14 font-weight-bold bluedarken--text">
          Summary By Activity
        </span>
        <v-spacer />
        <select-column-filter
          v-model="columnActivityActive"
          :headers="headersActivity"
        />
        <v-btn
          depressed
          dark
          color="menuActive"
          class="btn-medium"
          @click="download('activity')"
          :loadin="downloading.activity"
        >
          Download
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-simple-table class="nav-table">
          <template v-slot:default>
            <thead>
              <tr>
                <template v-for="(header, index) in headersActivity">
                  <th
                    v-if="isHeaderSelected(header, columnActivityActive)"
                    :key="header.text"
                    class="white--text"
                    :class="{ [`text-${header.align}`]: true }"
                  >
                    <span>{{ header.text }}</span>
                    <filter-column
                      v-if="header.value !== 'action'"
                      :indexItem="index"
                      :field="header.value"
                      :listFilter="getFiltered(header.value, itemsActivity)"
                      @sortAsc="getNestedSort($event, itemsActivity)"
                      @searchColumn="searchActivityCln"
                      @filterItem="searchActivityCln"
                    />
                  </th>
                </template>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in filteredActivityItems" :key="index">
                <template v-for="header in headersActivity">
                  <td
                    v-if="isColumnSelected(header.value, columnActivityActive)"
                    :key="header.name"
                    :class="{
                      [header.tdClass]: true,
                      [`text-${header.align}`]: true
                    }"
                  >
                    <template v-if="header.value === 'amount_budget'">
                      {{ idr(item.amount_budget) }}
                    </template>
                    <template v-else-if="header.value === 'ctr'">
                      {{ item.ctr.toFixed(2) }}
                    </template>
                    <template v-else-if="header.value === 'average_budget'">
                      {{ idr(item.average_budget) }}
                    </template>
                    <template v-else-if="header.value === 'action'">
                      <v-btn
                        text
                        color="primary"
                        class="text-capitalize font-weight-bold"
                        :to="toDetail(item, 'type_of_activity')"
                      >
                        <v-img
                          src="@/assets/images/icon-doc.png"
                          width="16"
                          height="16"
                          class="mr-2"
                          v-if="index !== filteredActivityItems.length"
                        />
                        Details
                      </v-btn>
                    </template>
                    <span v-else>
                      {{ header | tableRowValue(item) }}
                    </span>
                  </td>
                </template>
              </tr>
              <tr v-if="filteredActivityItems.length" class="total">
                <td
                  v-if="
                    isHeaderSelectedByValue('activity', columnActivityActive)
                  "
                >
                  Total
                </td>
                <td
                  v-if="
                    isHeaderSelectedByValue(
                      'number_of_requests',
                      columnActivityActive
                    )
                  "
                  class="text-right"
                >
                  {{ totalRequest(itemsActivity) }}
                </td>
                <td
                  v-if="
                    isHeaderSelectedByValue(
                      'amount_budget',
                      columnActivityActive
                    )
                  "
                  class="text-right"
                >
                  {{ totalBudget(itemsActivity) | toCurrencyWithoutSign }}
                </td>
                <td
                  v-if="isHeaderSelectedByValue('ctr', columnActivityActive)"
                  class="text-right"
                >
                  {{ totalCtr(itemsActivity) }} %
                </td>
                <td
                  v-if="
                    isHeaderSelectedByValue(
                      'average_budget',
                      columnActivityActive
                    )
                  "
                ></td>
                <td
                  v-if="isHeaderSelectedByValue('action', columnActivityActive)"
                ></td>
              </tr>
              <tr v-if="!filteredActivityItems.length">
                <td :colspan="headersActivity.length" class="text-center">
                  {{ loading ? 'Loading...' : 'No data available' }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import DashboardChart from '@/components/SSHCP/DashboardChart';
import DashboardPieChart from '@/components/SSHCP/DashboardPieChart';
import FilterColumn from '@/components/filterColumn';
import { mapState } from 'vuex';
import { exportToExcel } from '@/utils/helpers';
import { amountToFixed, BIDRFormat, MIDRFormat } from '@/mixins/filter';
import moment from 'moment';
import SelectColumnFilter from '@/components/SelectColumnFilter';

export default {
  props: {
    item: {}
  },
  components: {
    SelectColumnFilter,
    DashboardPieChart,
    DashboardChart,
    FilterColumn
  },
  data: () => ({
    items: [],
    itemsBudget: [],
    itemsActivity: [],
    filter: null,
    filterActivity: null,
    columnActive: [],
    columnActivityActive: [],
    loading: false,
    loadingBudget: false,
    downloading: {
      item: false,
      activity: false
    },
    panelFilter: null
  }),
  computed: {
    ...mapState('sshcp', {
      dashboard: 'dashboard',
      budgetChart: 'budgetChart',
      dashFilter: 'filter'
    }),
    headers() {
      return [
        {
          text: this.item.name,
          align: 'left',
          value: 'name'
        },
        {
          text: 'Number of Request',
          align: 'right',
          value: 'number_of_requests'
        },
        {
          text: 'Amount of Budget',
          align: 'right',
          value: 'amount_budget'
          // formatter: toCurrencyWithoutSign
        },
        {
          text: '% Ctr',
          align: 'right',
          value: 'ctr',
          formatter: amountToFixed
        },
        {
          text: 'Average of Budget',
          align: 'right',
          value: 'average_budget'
          // formatter: toCurrencyWithoutSign
        },
        {
          text: 'Action',
          align: 'center',
          value: 'action'
        }
      ];
    },
    headersActivity() {
      return [
        {
          text: 'Activity',
          align: 'left',
          value: 'activity'
        },
        {
          text: 'Number of Request',
          align: 'right',
          value: 'number_of_requests'
        },
        {
          text: 'Amount of Budget',
          align: 'right',
          value: 'amount_budget'
          // formatter: toCurrencyWithoutSign
        },
        {
          text: '% Ctr',
          align: 'right',
          value: 'ctr',
          formatter: amountToFixed
        },
        {
          text: 'Average of Budget',
          align: 'right',
          value: 'average_budget'
          // formatter: toCurrencyWithoutSign
        },
        {
          text: 'Action',
          align: 'center',
          value: 'action'
        }
      ];
    },
    stats() {
      return [
        {
          title: 'Number of Request',
          count: this.dashboard.numberOfRequest || '0',
          icon: 'icon-amount-hospital'
        },
        {
          title: 'Amount of Budget',
          count: `${BIDRFormat(this.dashboard.amountBudget || 0)} BIDR`,
          icon: 'icon-amount-support'
        },
        {
          title: 'Average of Budget',
          count: `${MIDRFormat(this.dashboard.averageAllBudget || 0)} MIDR`,
          icon: 'icon-average-support'
        }
      ];
    },
    filteredItems() {
      return this.getFilteredItems(this.items);
    },
    filteredActivityItems() {
      return this.getFilteredActivityItems(this.itemsActivity);
    },
    isSelectedAll: {
      get() {
        return this.headers
          ? this.columnActive.length === this.headers.length
          : false;
      },
      set(value) {
        const selected = [];

        if (value) {
          this.headers.forEach(function(user) {
            selected.push(user);
          });
        }

        this.columnActive = selected;
      }
    },
    isActivitySelectedAll: {
      get() {
        return this.headersActivity
          ? this.columnActivityActive.length === this.headersActivity.length
          : false;
      },
      set(value) {
        const selected = [];

        if (value) {
          this.headersActivity.forEach(function(user) {
            selected.push(user);
          });
        }

        this.columnActivityActive = selected;
      }
    },
    headersWithoutAction() {
      return this.headers.filter(item => item.value !== 'action');
    },
    filterInfo() {
      let filter = this.dashFilter;
      let info = [];
      for (const property in filter) {
        if (property !== 'isSubmit' && filter[property]) {
          info.push({
            name: property,
            value: filter[property]
          });
        }
      }
      return info;
    }
  },
  watch: {
    item: {
      immediate: true,
      async handler(val) {
        await this.fetch({
          groupBy: val.name.toLowerCase()
        });
        await this.fetchBudgetChart();
        this.selectAllColumn();
      }
    },
    dashFilter: {
      deep: true,
      handler(filter) {
        if (filter.isSubmit) {
          this.refresh();
        }

        if (filter.isDownload) {
          this.download();
        }
      }
    },
    panelFilter() {
      if (this.filterInfo.length > 0) {
        this.panelFilter = 0;
      } else {
        this.panelFilter = null;
      }
    },
    filterInfo() {
      if (this.filterInfo.length > 0) {
        this.panelFilter = 0;
      } else {
        this.panelFilter = null;
      }
    }
  },
  created() {
    this.selectAllColumn();
    this.selectActivityAllColumn();
  },
  mounted() {
    this.resetFilter();
  },
  methods: {
    resetFilter() {
      this.$store.commit('sshcp/set', {
        filter: {
          start_year: '',
          start_created_date: '',
          end_created_date: '',
          start_submitted_date: '',
          end_submitted_date: '',
          start_approved_date: '',
          end_approved_date: '',
          house: null,
          region: null,
          district: null,
          type_of_activity: null,
          status: null,
          isSubmit: true
        }
      });
    },
    async refresh() {
      await this.fetch();
      await this.fetchBudgetChart();
      this.selectAllColumn();
    },
    selectAllColumn() {
      this.columnActive = this.headers;
    },
    selectActivityAllColumn() {
      this.columnActivityActive = this.headersActivity;
    },
    async fetch(params = {}) {
      this.loading = true;
      let status = null;
      if (this.dashFilter.status) {
        status = {
          field: 'local_status',
          data: this.dashFilter.status
        };
      }
      let start_year = '';
      if (this.dashFilter.start_year) {
        start_year = moment(this.dashFilter.start_year).format('YYYY');
      }
      let payload = {
        start_year: start_year || null,
        start_created_date: this.dashFilter.start_created_date || null,
        end_created_date: this.dashFilter.end_created_date || null,
        start_date_submitted: this.dashFilter.start_date_submitted || null,
        end_date_submitted: this.dashFilter.end_date_submitted || null,
        start_date_fully_approved:
          this.dashFilter.start_date_fully_approved || null,
        end_date_fully_approved:
          this.dashFilter.end_date_fully_approved || null,
        house_id: this.dashFilter.house?.id,
        region: this.dashFilter.region,
        district: this.dashFilter.district,
        filterArray: status,
        type_of_activity: this.dashFilter.type_of_activity || null
      };
      const res = await this.$store.dispatch('sshcp/getDashboard', {
        groupBy: this.item.name.toLowerCase(),
        ...payload,
        ...params
      });
      this.loading = false;
      this.items = res.data.formRequestGroup;
      this.itemsActivity = res.data.formRequestPerActivity;

      this.$store.commit('sshcp/set', {
        ...this.filter,
        isSubmit: false
      });
    },
    async fetchBudgetChart(params = {}) {
      this.loadingBudget = true;
      let status = null;
      if (this.dashFilter.status) {
        status = {
          field: 'local_status',
          data: this.dashFilter.status
        };
      }
      let start_year = '';
      if (this.dashFilter.start_year) {
        start_year = moment(this.copy(this.dashFilter.start_year)).format(
          'YYYY'
        );
      }
      let payload = {
        start_year: start_year || null,
        start_created_date: this.dashFilter.start_created_date || null,
        end_created_date: this.dashFilter.end_created_date || null,
        start_date_submitted: this.dashFilter.start_date_submitted || null,
        end_date_submitted: this.dashFilter.end_date_submitted || null,
        start_date_fully_approved:
          this.dashFilter.start_date_fully_approved || null,
        end_date_fully_approved:
          this.dashFilter.end_date_fully_approved || null,
        house_id: this.dashFilter.house?.id,
        region: this.dashFilter.region,
        district: this.dashFilter.district,
        filterArray: status,
        type_of_activity: this.dashFilter.type_of_activity || null
      };
      const res = await this.$store.dispatch('sshcp/getBudgetChart', {
        ...payload,
        ...params
      });
      this.loadingBudget = false;
      this.itemsBudget = res.data;
    },
    toggleSelectAll() {
      this.isSelectAll = !this.isSelectAll;
    },
    isHeaderSelected(header, column) {
      return column.map(item => item.value).includes(header.value);
    },
    isHeaderSelectedByValue(value, column) {
      return column.map(item => item.value).includes(value);
    },
    isColumnSelected(name, column) {
      return column.filter(item => item.value === name).length > 0;
    },
    totalRequest(items) {
      return items.reduce((previousValue, currentValue) => {
        return previousValue + currentValue.number_of_requests;
      }, 0);
    },
    totalBudget(items) {
      return items.reduce((previousValue, currentValue) => {
        return previousValue + currentValue.amount_budget;
      }, 0);
    },
    totalCtr(items) {
      return items.reduce((previousValue, currentValue) => {
        return previousValue + currentValue.ctr;
      }, 0);
    },
    getNestedSort(obj, items) {
      this.nestedSort(obj.fieldName, items);
    },
    searchCln(obj) {
      this.filter = obj;
    },
    searchActivityCln(obj) {
      this.filterActivity = obj;
    },
    getFilteredItems() {
      const obj = this.filter;
      let arr = this.items;

      if (!obj) return arr;

      let nameField = obj.fieldName;
      let valSearch = Array.isArray(obj.value)
        ? obj.value.join('|').toLowerCase()
        : obj.value.toLowerCase();
      let result = [];
      if (!nameField.includes('.')) {
        /*search array of object*/
        if (nameField === 'start') {
          nameField = 'dateStart';
        } else if (nameField === 'end') {
          nameField = 'dateEnd';
        }
        result = arr.filter(function(a) {
          if (a[nameField] !== null) {
            if (Array.isArray(obj.value)) {
              return obj.value.includes(String(a[nameField]));
            } else {
              return a[nameField]
                .toString()
                .toLowerCase()
                .match(valSearch);
            }
          }
        });
      } else {
        /*search array of nested object*/
        let arrObj = nameField.split('.');
        if (arrObj.length === 2) {
          result = arr.filter(function(a) {
            if (a[arrObj[0]][arrObj[1]] !== null) {
              if (Array.isArray(obj.value)) {
                return obj.value.includes(a[arrObj[0]][arrObj[1]].toString());
              } else {
                return a[arrObj[0]][arrObj[1]]
                  .toString()
                  .toLowerCase()
                  .match(valSearch);
              }
            }
          });
        } else if (arrObj.length === 3) {
          result = arr.filter(function(a) {
            if (a[arrObj[0]][arrObj[1]][arrObj[2]] !== null) {
              if (Array.isArray(obj.value)) {
                return obj.value.includes(
                  a[arrObj[0]][arrObj[1]][arrObj[2]].toString()
                );
              } else {
                return a[arrObj[0]][arrObj[1]][arrObj[2]]
                  .toString()
                  .toLowerCase()
                  .match(valSearch);
              }
            }
          });
        } else if (arrObj.length === 4) {
          result = arr.filter(function(a) {
            if (a[arrObj[0]][arrObj[1]][arrObj[2]][arrObj[3]] !== null) {
              if (Array.isArray(obj.value)) {
                return obj.value.includes(
                  a[arrObj[0]][arrObj[1]][arrObj[2]][arrObj[3]].toString()
                );
              } else {
                return a[arrObj[0]][arrObj[1]][arrObj[2]][arrObj[3]]
                  .toString()
                  .toLowerCase()
                  .match(valSearch);
              }
            }
          });
        } else {
          result = this.items;
        }
      }

      return result;
    },
    getFilteredActivityItems() {
      const obj = this.filterActivity;
      let arr = this.itemsActivity;

      if (!obj) return arr;

      let nameField = obj.fieldName;
      let valSearch = Array.isArray(obj.value)
        ? obj.value.join('|').toLowerCase()
        : obj.value.toLowerCase();
      let result = [];
      if (!nameField.includes('.')) {
        /*search array of object*/
        if (nameField === 'start') {
          nameField = 'dateStart';
        } else if (nameField === 'end') {
          nameField = 'dateEnd';
        }
        result = arr.filter(function(a) {
          if (a[nameField] !== null) {
            if (Array.isArray(obj.value)) {
              return obj.value.includes(String(a[nameField]));
            } else {
              return a[nameField]
                .toString()
                .toLowerCase()
                .match(valSearch);
            }
          }
        });
      } else {
        /*search array of nested object*/
        let arrObj = nameField.split('.');
        if (arrObj.length === 2) {
          result = arr.filter(function(a) {
            if (a[arrObj[0]][arrObj[1]] !== null) {
              if (Array.isArray(obj.value)) {
                return obj.value.includes(a[arrObj[0]][arrObj[1]].toString());
              } else {
                return a[arrObj[0]][arrObj[1]]
                  .toString()
                  .toLowerCase()
                  .match(valSearch);
              }
            }
          });
        } else if (arrObj.length === 3) {
          result = arr.filter(function(a) {
            if (a[arrObj[0]][arrObj[1]][arrObj[2]] !== null) {
              if (Array.isArray(obj.value)) {
                return obj.value.includes(
                  a[arrObj[0]][arrObj[1]][arrObj[2]].toString()
                );
              } else {
                return a[arrObj[0]][arrObj[1]][arrObj[2]]
                  .toString()
                  .toLowerCase()
                  .match(valSearch);
              }
            }
          });
        } else if (arrObj.length === 4) {
          result = arr.filter(function(a) {
            if (a[arrObj[0]][arrObj[1]][arrObj[2]][arrObj[3]] !== null) {
              if (Array.isArray(obj.value)) {
                return obj.value.includes(
                  a[arrObj[0]][arrObj[1]][arrObj[2]][arrObj[3]].toString()
                );
              } else {
                return a[arrObj[0]][arrObj[1]][arrObj[2]][arrObj[3]]
                  .toString()
                  .toLowerCase()
                  .match(valSearch);
              }
            }
          });
        } else {
          result = this.itemsActivity;
        }
      }

      return result;
    },
    getFiltered(name, items) {
      if (!name.includes('.')) {
        return Object.keys(
          items.reduce((result, arr) => {
            result[arr[name]] = [...(result[arr[name]] || []), arr];
            return result;
          }, {})
        );
      } else {
        let nameField = name.split('.');
        return Object.keys(
          items.reduce((result, arr) => {
            if (!arr[nameField[0]]) return;
            result[arr[nameField[0]][nameField[1]]] = [
              ...(result[arr[nameField[0]][nameField[1]]] || []),
              arr
            ];
            return result;
          }, {})
        );
      }
    },
    async download(type) {
      this.downloading[type] = true;
      const name = type === 'item' ? this.items : this.itemsActivity;
      const itemsType =
        type === 'item' ? this.filteredItems : this.filteredActivityItems;
      const headersType = type === 'item' ? this.headers : this.headersActivity;
      const headers = headersType.filter(item => item.value !== 'action');
      const columns = headers.map(item => item.text);
      const items = itemsType.map(item =>
        headers.map(header =>
          header.formatter
            ? header.formatter(item[header.value])
            : item[header.value]
        )
      );
      items.push([
        'Total',
        this.totalRequest(name),
        this.totalBudget(name),
        this.totalCtr(name)
      ]);

      const date = moment().format('YYYY-MM-DD-HHmmss');
      const fileName =
        type === 'item'
          ? `Dashboard-Reports-Summary-${this.item.name}-${date}`
          : `Dashboard-Reports-Summary-Activity-${date}`;

      await exportToExcel(columns, items, fileName);

      this.downloading[type] = false;
      this.$store.commit('sshcp/set', {
        ...this.filter,
        isDownload: false
      });
    },
    toDetail(item, type) {
      let filter = '';
      let key = type.toLowerCase();
      if (key === 'house') {
        filter = `house_id=${item.house_id}&house_name=${item.name}`;
      } else if (key === 'type_of_activity') {
        filter = `name=${item.activity}`;
      } else {
        filter = `name=${item.name}`;
      }
      return `/sshcp/request?${filter}&typeFilter=${key}`;
    }
  }
};
</script>

<style>
.filterby-info .v-expansion-panel-header__icon {
  margin-left: 0px !important;
}
.v-expansion-panel-content__wrap {
  padding: 0 1px !important;
}
</style>
